import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'isNullOrWhitespace',
})
export class IsNullOrWhitespacePipe implements PipeTransform {
  transform(text: string): boolean {
    return String.isNullOrWhiteSpace(text);
  }
}
